import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";
import styled from "styled-components";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function DetailsDesktop({ app, config }) {
  const [selectedValueCargo, setSelectedValueCargo] = useState("Gerente Geral");
  const { selections } = useSelections();

  const [selectedGroup, setSelectedGroup] = useState("");
  const [singleGroupView, setSingleGroupView] = useState(false);

  const handleChange = (event) => {
    app.field("Tipo_Analise").selectMatch(event.target.value, true);
    setSelectedValueCargo(event.target.value);
  };

  useEffect(() => {
    if (app) {
      // update title with selected distributor (when only 1 is selected)
      const cargos = selections.length
        ? selections.find((s) => s.qField === "Tipo_Analise")
        : null;
      const distributors = selections.length
        ? selections.find((s) => s.qField === "Desc_Pasta")
        : null;
      setSelectedValueCargo(cargos?.qSelected);
      setSelectedGroup(
        distributors
          ? distributors?.qSelectedCount === 1
            ? `: ${distributors.qSelected}`
            : ""
          : ""
      );
      setSingleGroupView(distributors?.qSelectedCount === 1);
    }
  }, [app, selections]);

  return (
    <div className="app deatil">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid container rowGap={2}>
            <LayoutCardWrapper
              style={{
                paddingLeft: "10px",
                marginTop: "16px",
                height: "calc(100vh - 100px)",
              }}
            >
              <Card
                app={app}
                exportTable
                exportTableId="YVhzrtK"
                exportContainer
                header={{
                  hardTitle: "Apuração",
                }}
                style={{ width: "100%", height: "100%" }}
                className={"container-table"}
              >
                <FormControl className="container-form-control">
                  <RadioGroup
                    defaultValue="Gerente Geral"
                    row
                    name="row-radio-buttons-group"
                    className="radio-group radio-group-button-export"
                    value={selectedValueCargo}
                    onChange={handleChange}
                  >
                    <FormControlLabel
                      value="Gerente Geral"
                      control={
                        <Radio
                          size="small"
                          defaultChecked
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Gerente geral"
                    />

                    <FormControlLabel
                      value="Gerente"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Gerente"
                    />

                    <FormControlLabel
                      value="Supervisor"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Supervisor"
                    />

                    <FormControlLabel
                      value="Vendedor Compartilhada"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Vendedor Compartilhada"
                    />

                    <FormControlLabel
                      value="Vendedor Exclusiva"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Vendedor Exclusiva"
                    />

                    <FormControlLabel
                      value="Executivo Reppos"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#5A2882",
                            "&.Mui-checked": {
                              color: "#5A2882",
                            },
                          }}
                        />
                      }
                      label="Executivo Reppos"
                    />
                  </RadioGroup>
                </FormControl>

                <NativeObject
                  app={app}
                  key="YVhzrtK"
                  reference={{ id: "YVhzrtK" }}
                />
              </Card>
            </LayoutCardWrapper>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DetailsDesktop.defaultProps = {
  app: null,
  config: {},
};

DetailsDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DetailsDesktop;
